/*eslint-disable*/
import React, { useState, useContext, useEffect, useRef } from 'react';
import "react-bootstrap-wizard/dist/react-wizard.css";
import "bootstrap/dist/css/bootstrap.css";
import { useNavigate, useLocation } from "react-router-dom";
import UpdateStepper from "components/UpdateStepper.js";
import { STYLES } from "config";
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import {
    Button,
    Input as RSInput,
} from "reactstrap";
import moment from 'moment';
import CircularLoading from "components/CircularLoading";
import CustomDropDownPicker from 'components/CustomDropDownPicker';
import PropertyTypeDropdown from '../../components/PropertyTypeDropdown';
import CustomImageDragger from "../../components/CustomeImageDraggerOgURL";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import FlatList from "flatlist-react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { clearListingErrors, } from 'common/src/actions/Listingactions';

const styles = {
    Card: {
        padding: "5px",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    MinimizeBtn: {
        border: "none",
        background: "transparent",
        fontSize: "18px",
        cursor: "pointer",
        color: "#666",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        gap: "20px",
    },
    DropdownWrapper: {
        width: "100%",
        position: "relative",
        //zIndex: 2"" // keeps dropdown above neighbors
    },
    CardHeader: {
        padding: "5px",
        width: "100%",
    },
    CardBody: {
        padding: "10px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "30px",
    },
    text: {
        color: "grey",
    },
    inputStyle: {
        borderWidth: 1,
        borderColor: STYLES.TERTIARY_APP_CLR,
        height: 44,
        backgroundColor: "white",
        fontSize: 16,
        borderRadius: 4,
        color: "grey",
    },
    Row: { display: "flex", flexDirection: "row", gap: "15px" },
    card: {
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
    },
    label: {
        fontWeight: 'bold',
        marginRight: '4px',
    },
    scrollableBody: {
        maxHeight: '70vh',
        overflowY: 'auto',
        paddingRight: '12px',
    },
    disabledField: {
        backgroundColor: '#f5f5f5',
        color: '#b0b0b0',
    },
    CheckboxWrapper: {
        alignItems: "center",
        width: "100%",
        flexDirection: "row",
        gap: "8px",
        padding: " 6px",
        border: "2px solid #ccc",
        borderRadius: "4px",
        background: "#fafafa",
    },
};

const Input = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'grey',
            borderWidth: 2,
        },
        '&:hover fieldset': {
            borderColor: '#999',
        },
        '&.Mui-focused fieldset': {
            borderLeftWidth: 4,
            padding: '4px !important',
        },
    },
    '& input': {
        color: 'grey',
    },
});

function StaffDuplicateListing({ navigation, route }) {
    const location = useLocation();
    const [data, setdata] = useState(location.state?.item);
    const [collapsed, setCollapsed] = useState(false);
    const [onMarketSince, setOnMarketSince] = useState("");
    const [mandateStartDate, setMandateStartDate] = useState("");
    const [mandateEndDate, setMandateEndDate] = useState("");
    const [listingData, setListingData] = useState(data);
    const [validImages, setValidImages] = useState([]);

    const aiMarketingReducer = useSelector((state) => state.aidata);
    const areaData = useSelector((state) => state.areaData);
    const fileInputRef = useRef(null);
    const [areaList, setAreaList] = useState([]);
    const [captions, setCaptions] = useState({});


    const auth = useSelector((state) => state.auth);
    const brokers = useSelector((state) => state.brokers.users);
    const listingManagementReducer = useSelector((state) => state.ListingData);
    const landlordManagementReducer = useSelector((state) => state.landlorddata);
    const { api } = useContext(FirebaseContext);
    const { UpdateListing, GenerateListingDescription, clearAiReducer, duplicateListing } = api;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);

    const [image, setImage] = useState(Object.values(data.images ? data.images : {}));
    const [brokerList, setBrokerList] = useState([]);
    const availableFromOptions = [{ label: "Immediately", value: "Immediately" },
    { label: "Negotiable", value: "Negotiable" },
    { label: "Specific Date", value: "Specific Date" },];
    const leasePeriods = [{ label: "1 month", value: "1" },
    { label: "2 month", value: "2" },
    { label: "3 month", value: "3" },
    { label: "6 month", value: "6" },
    { label: "9 months", value: "9" },
    { label: "12 month", value: "12" },
    { label: "24 month", value: "24" },
    { label: "36 month", value: "36" },
    { label: "48 month", value: "48" },
    { label: "60 month", value: "60" },
    { label: "10 year plus", value: "120" },
    { label: "15 year plus", value: "180" },
    { label: "25 year plus", value: "300" },
    { label: "35 year plus", value: "420" },
    { label: "Negotiable", value: "Negotiable" },];

    const leaseTypes = [

        { label: "Percentage", value: "Percentage" },

        { label: "Net", value: "Net" },
        { label: "Double Net", value: "DoubleNet" },
        { label: "Triple Net", value: "TripleNet" },
        { label: "Fully Serviced Lease Gross", value: "FullyServicedLeaseGross" },]
    const buildingGrades = [
        { value: "A", label: "A" },
        { value: "AAA", label: "AAA" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "P", label: "P" }

    ];
    const locationOptions = [
        { value: "address", label: "Address" },
        { value: "suburb", label: "Suburb" },
    ];
    const truckAccessOptions = [
        { value: "Small_Trucks", label: "Small Trucks" },
        { value: "Single_Trailer", label: "Single Trailer" },
        { value: "Interlink", label: "Interlink" },
        { value: "Superlink", label: "Superlink" }
    ];
    const [state, setstate] = useState({
        availabilityOption: "",
        status: "Active",
        municipalValue: "",
        buildingGrade: "",
        valuationPrice: "",
        gla: "",
        address: "",
        standSize: "",
        type: "",
        erf: "",
        deposit: "",
        location: "",
        // title: "",
        postalAddress: "",
        Street: "",
        typeOfProperty: false,
        typeOfMandate: "",
        typeOfTitle: "",
        unit: "",
        monthlyLevy: "",
        // complexName: "",    
        monthlyLevyPerSQM: "",

        specialLevy: "",
        floorLoading: "",
        truckAccess: "",
        yardAccess: "",
        parkingType: "",
        threePhasePower: false,
        buildingGrades: "",
        powerAmps: "",
        heightForRacking: "",
        heightToEaves: "",
        sprinklered: false,
        rollerShutterDoors: "",
        heightOfRollerShutterDoors: "",
        studHeight: "",
        dockLevellers: "",
        heightOfDockLevellers: "",
        security: false,
        airConditioning: false,
        multiTenanted: false,
        leaseType: "",
        leasePeriod: "",
        onMarketSince: "",
        availableFrom: "",

        additionalNotes: "",


        price: "",
        openParkingBays: "",
        openParkingCostPerBay: "",
        openParkingTotalCost: "",
        basementParkingBays: "",
        basementParkingCostPerBay: "",
        basementParkingTotalCost: "",
        coveredParkingTotalCost: "",
        coveredParkingBays: "",
        coveredParkingCostPerBay: "",
        saleboth: "",
        poa: false,
        officeSize: "",
        officePrice: "",
        retailSize: "",
        retailPrice: "",
        factorySize: "",
        factoryPrice: "",
        yardSize: "",
        yardPrice: "",
        landSize: "",
        landSizeMeasurement: "sqm",
        floorSize: "",
        Description: "",
        floorNumber: "",
        floorSizeMeasurement: "sqm",
        industrialCommercial: "",
        buildingHieght: "",
        grossmonthlyRental: "",
        ownerBroker: "",
        showLocation: false,
        locationType: "",
        office: auth.info.profile.adminHomeOffice,
        seller: {
            entityName: "",
            monthlyRates: "",
            registrationNumber: "",
            postalAddress: "",
            ownername: "",
            company: "",
            cellTel: "",
            homeTel: "",
            workTel: "",
            Deposit: "",
            investor: false,
            email: "",
            monthlyLevy: "",
            monthlyLevyPerSQM: "",
            specialLevy: "",
            vatVendor: false,
            vatNumber: "",
        },
    });

    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex =
        /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;


    useEffect(() => {
        if (
            listingManagementReducer.completed &&
            listingManagementReducer.success
        ) {

            alert(
                "Listing Duplicated",
                "",
                [
                    {
                        text: "OK",
                        onPress: () => { dispatch(clearListingErrors()) },
                    },
                ]
            );
            navigate("/stockdetials", {
                state: { item: listingManagementReducer.currentListing },
            });

        }

        if (
            !listingManagementReducer.success &&
            listingManagementReducer.error.flag
        ) {
            console.log(
                "listingManagementReducer.error",
                listingManagementReducer.error.msg
            );
            alert(
                `\tDuplicate Listing Failed \n ${listingManagementReducer.error.msg}`
            );
            dispatch(clearListingErrors());
        }
    }, [listingManagementReducer]);


    useEffect(() => {
        console.log('image', image)
        let images = {}
        for (let index = 0; index < image.length; index++) {
            const element = image[index];
            images[`Image${index}`] = element.url;

            if (index === image.length - 1) {
                setValidImages(images);
            }

        }



    }, [image])


    const handleGenerateDescription = () => {
        let ListingData = { ...state, markertingHeading: "", description: "" }
        dispatch(GenerateListingDescription(ListingData));
    };

    const saveCordsData = (location, data) => {
        setstate({
            ...state,
            address: { ...state?.address, coords: { ...state.address.coords, [location]: data } },
        });
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };



    useEffect(() => {
        let arr2 = [];
        if (areaData && areaData.areas) {
            for (let index = 0; index < areaData.areas.length; index++) {
                const element = areaData.areas[index];
                if (element.selectedBranchName === auth?.info?.profile?.adminHomeOffice) {
                    arr2.push({
                        value: element.areaId,
                        label: element.areaName
                    });
                }
            }
            setAreaList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
        }
    }, [areaData]);

    useEffect(() => {
        if (!aiMarketingReducer.loadingDescription && aiMarketingReducer.completed) {
            setstate({
                ...state,
                marketingHeading: aiMarketingReducer.aiGeneratedTitle,
                description: aiMarketingReducer.aiGeneratedDescription
            });
            dispatch(clearAiReducer());
        }
    }, [aiMarketingReducer]);


    const mandateTypes = [
        { value: "Open", label: "Open", },
        { value: "Sole", label: "Sole", },
        { value: "None", label: "None", },
        { value: "Company Listing", label: "Company Listing", },
        { value: "Shared", label: "Shared", },
        { value: "Referral", label: "Referral", }
    ];

    const usageTypes = [
        { value: "Commercial", label: "Commercial", },
        { value: "Industrial", label: "Industrial", },
    ];

    const listingTypes = [
        { value: "both", label: "Both" },
        { value: "tolet", label: "To Let" },
        { value: "sale", label: "For Sale" }
    ];

    const titleTypes = [
        { value: "Freehold", label: "Freehold" },
        { value: "Sectional Title", label: "Sectional Title" },
        { value: "None", label: "None" },
        { value: "Share Block", label: "Share Block" }
    ];

    const availabilityTypes = [
        { value: "Immediate", label: "Immediate" },
        { value: "Negotiable", label: "Negotiable" },
        { value: "Specific Date", label: "Specific Date" },
    ];

    useEffect(() => {

        if (listingData) {
            setstate({
                ...state,
                ...listingData,
                seller: {
                    ...state.seller,
                    ...(listingData.seller || {}),
                },
                address: {
                    ...state.address,
                    ...(listingData.address || {}),
                    coords: listingData.address?.coords || { lat: 0.0, lng: 0.0 }
                },
            });
        }
        // eslint-disable-next-line
    }, [listingData]);


    useEffect(() => {
        let rawImages = data?.images;
        // Fix common misformats (array, object, null)
        const imagesArray = Array.isArray(rawImages)
            ? rawImages
            : rawImages && typeof rawImages === "object"
                ? Object.values(rawImages)
                : [];

        const validImages = imagesArray
            .filter((url) => typeof url === "string")
            .map((url, index) => ({
                url,
                name: `image-${index}` // generate a unique name
            }));

        setImage(validImages);
    }, [data.images]);

    useEffect(() => {
        let arr = [];
        if (brokers) {
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id,
                        label: `${element.firstName} ${element.lastName}`,
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }
    }, [brokers, auth]);

    useEffect(() => {
        if (data) {
            setstate(data);
        }
    }, [data]);

    const saveData = (location, data) => {
        setstate({
            ...state,
            [location]: data,
        });
    };

    const saveAddressData = (location, data) => {
        setstate({
            ...state,
            address: { ...state?.address, [location]: data },
        });
    };

    const toggleTwo = () => setIsOpen(!isOpen);

    function onImageChange(e) {
        setImage((prev) => [...prev, ...e.target.files]);
        setCaptions(Object.fromEntries(Object.values(e.target.files).map(file => [file.name, ""])));
    }

    const saveUserData = (location, data) => {
        setstate({
            ...state,
            seller: {
                ...state.seller,
                [location]: data,
            },
        });
    };

    const RenderModal = () => {
        const [filteredLandlords, setfilteredLandlords] = useState([]);
        function filterLandlords(text) {
            if (text.length > 0) {
                setfilteredLandlords(landlordManagementReducer.landlords.filter((landlord) => {
                    const search = text.toLowerCase();
                    return (
                        landlord.ownerName?.toLowerCase().includes(search) ||
                        landlord.companyName?.toLowerCase().includes(search) ||
                        landlord.companyRegNumber?.toLowerCase().includes(search) ||
                        landlord.companyEmail?.toLowerCase().includes(search) ||
                        landlord.companyContactNumber?.toLowerCase().includes(search)
                    );
                }));
            } else {
                setfilteredLandlords([]);
            }
        }
        const RenderItem = ({ ownerName, companyName, companyRegNumber, companyEmail, companyContactNumber }) => {
            return (
                <div style={styles.card} onClick={() => {
                    setstate({
                        ...state,
                        seller: {
                            ...state.seller,
                            ownername: ownerName,
                            company: companyName,
                            registrationNumber: companyRegNumber,
                            email: companyEmail,
                            cellTel: companyContactNumber,
                        },
                    })
                    setIsOpen(false);
                }}>
                    <p style={styles.text}><span style={styles.label}>Owner:</span> {ownerName}</p>
                    <p style={styles.text}><span style={styles.label}>Company:</span> {companyName}</p>
                    <p style={styles.text}><span style={styles.label}>Reg. Number:</span> {companyRegNumber}</p>
                    <p style={styles.text}><span style={styles.label}>Email:</span> {companyEmail}</p>
                    <p style={styles.text}><span style={styles.label}>Contact:</span> {companyContactNumber}</p>
                </div>
            );
        };
        return (
            <Modal style={{ cursor: "pointer" }} isOpen={isOpen} toggle={toggleTwo} centered>
                <ModalHeader>Import Owner Details</ModalHeader>
                <ModalBody style={styles.scrollableBody}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            filterLandlords(value.target.value);
                        }}
                        type="text"
                        label="search for a landlord"
                    />
                    <FlatList
                        keyExtractor={(item, index) => index.toString()}
                        list={filteredLandlords.length > 0 ? filteredLandlords : landlordManagementReducer.landlords || []}
                        renderOnScroll
                        renderItem={(item) => <RenderItem {...item} />}
                        renderWhenEmpty={() =>
                            <div>
                                <p>There currently is no Landlord please go and make a new landlord contact!</p>
                                <Button>
                                    <a onClick={() => {
                                        navigate("/manageLandlords");
                                    }} style={{ color: "white" }}>Go to Landlords</a>
                                </Button>
                            </div>}
                    />
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    };

    return landlordManagementReducer.loading || listingManagementReducer.loading ? (
        <CircularLoading label={"Just a Minute Getting Everything Done For You"} />
    ) : (
        <div style={styles.container}>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className='h4' style={styles.text}>Listing Details</p>
                </div>

                <div style={styles.CardBody}>

                    <div style={styles.Row}>

                        <div style={{
                            width: "100%",
                            zIndex: 10
                        }}>
                            <PropertyTypeDropdown
                                value={state.typeOfProperty}
                                onChange={(selectedProperty, p24Value, ppValue) => {
                                    setstate({
                                        ...state,
                                        typeOfProperty: selectedProperty,
                                        p24propertyType: p24Value,
                                        pppropertyType: ppValue
                                    });
                                }}
                            />
                        </div>

                        <div style={{ width: "100%", zIndex: 10 }}><CustomDropDownPicker
                            borderColor="grey"
                            options={usageTypes}
                            isMulti={false}
                            value={state.industrialCommercial}
                            onChange={(e) => saveData("industrialCommercial", e)}
                            placeholder="Select A Usage Type"
                        /></div>

                    </div>



                    <div style={styles.Row}>

                        <div style={{
                            width: "100%",
                            zIndex: 8
                        }}><CustomDropDownPicker
                                borderColor="grey"
                                options={listingTypes}
                                isMulti={false}
                                value={state.type}
                                onChange={(e) => saveData("type", e)}
                                placeholder="Select A Listing Type"
                            /></div>

                        <div style={{ width: "100%", zIndex: 8 }}><CustomDropDownPicker
                            borderColor="grey"
                            options={titleTypes}
                            isMulti={false}
                            value={state.typeOfTitle}
                            onChange={(e) => saveData("typeOfTitle", e)}
                            placeholder="Select A Title Type"
                        /></div>

                    </div>


                    <div style={styles.Row}>

                        <div style={{
                            width: "100%",
                            zIndex: 5
                        }}><CustomDropDownPicker
                                borderColor="grey"
                                options={availabilityTypes}
                                value={state.availabilityOption}
                                isMulti={false}
                                onChange={(e) => {
                                    const today = moment().format("YYYY-MM-DD");

                                    console.log('state.', state.availabilityOption)
                                    console.log('state.', state.availableFrom)
                                    if (e === 'Immediate') {
                                        setstate({
                                            ...state,
                                            availableFrom: today,
                                            availabilityOption: e,
                                        })


                                    }

                                    if (e === 'Negotiable') {
                                        setstate({
                                            ...state,
                                            availableFrom: "To Be Decided",
                                            availabilityOption: e,
                                        })
                                    }

                                    if (e === 'Specific Date') {
                                        setstate({
                                            ...state,
                                            availableFrom: null,
                                            availabilityOption: e,
                                        })
                                    }
                                }}
                                placeholder="Select Availability Option"
                            /></div>



                        <div style={{
                            width: "100%",
                            zIndex: 5
                        }}><CustomDropDownPicker
                                borderColor="grey"
                                options={brokerList}
                                isMulti={false}
                                value={state.ownerBroker}
                                required
                                onChange={(e) => saveData("ownerBroker", e)}
                                placeholder="Select A Broker"
                            /></div>

                    </div>
                </div>

                <div style={styles.CardBody}>
                    <div style={{ ...styles.Row, zIndex: 2 }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("erf", value.target.value);
                            }}
                            type="text"
                            value={state.erf ? state.erf : " "}
                            label="erf number"
                        />
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={mandateTypes}
                                isMulti={false}
                                onChange={(value) => {
                                    saveData("typeOfMandate", value);
                                }}
                                value={state?.typeOfMandate}
                                placeholder="Select Type of Mandate"
                            />
                        </div>
                    </div>
                    <div style={styles.Row}>
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={availabilityTypes}
                                isMulti={false}
                                onChange={(e) => {
                                    const today = moment().format("YYYY-MM-DD");
                                    if (e === 'Immediate') {
                                        setstate({
                                            ...state,
                                            availableFrom: today,
                                            availabilityOption: e,
                                        })
                                    }
                                    if (e === 'Negotiable') {
                                        setstate({
                                            ...state,
                                            availableFrom: "To Be Decided",
                                            availabilityOption: e,
                                        })
                                    }
                                    if (e === 'Specific Date') {
                                        setstate({
                                            ...state,
                                            availableFrom: null,
                                            availabilityOption: e,
                                        })
                                    }
                                }}
                                value={state.availabilityOption || null}
                                placeholder="Select Availability Option"
                            />
                        </div>
                        <Input
                            fullWidth
                            disabled={state.availabilityOption !== "Specific Date"}
                            type="date"
                            style={styles.inputStyle}
                            value={
                                state.availableFrom && state.availableFrom !== "To Be Decided"
                                    ? state.availableFrom
                                    : ""
                            }
                            placeholder="Available From"
                            onChange={(e) => { saveData("availableFrom", e.target.value) }}
                        />
                    </div>
                    <div style={styles.Row}><div style={{
                        width: "100%",
                    }}>
                        <Input
                            multiline
                            variant="outlined"
                            rows={4}
                            fullWidth
                            value={state?.notes || state?.additionalNotes}
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("additionalNotes", value.target.value);
                            }}
                            type="text"
                            label="Notes"
                        />
                    </div>
                    </div>
                </div>
            </div>
            <div style={styles.Card}>
                <div className={styles.CardHeader}> <p className='h4' style={styles.text}>Address Details</p>  </div>
                <div style={styles.CardBody}>
                    <div style={{ flex: 1 }}>
                        <GoogleMapsAutoComplete
                            onChange={(value) => {
                                setstate({
                                    ...state,
                                    address: {
                                        ...state.address,
                                        description: value?.description || "",
                                        coords: {
                                            lat: value?.location?.latitude,
                                            lng: value?.location?.longitude
                                        }
                                    },
                                });
                            }}
                            placeholder="Search Address"
                            value={state.address?.description || ""}
                        />
                    </div>
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("streetNumber", value.target.value);
                            }}
                            value={state.address.streetNumber || ""}
                            fullWidth
                            type="text"
                            label="Street Number"
                        />
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("streetName", value.target.value);
                            }}
                            fullWidth
                            type="text"
                            value={state.address.streetName || ""}
                            label="Street Name"
                        />
                    </div>
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("unitNumber", value.target.value);
                            }}
                            fullWidth
                            type="text"
                            value={state.address.unitNumber || ""}
                            label="Unit Number"
                        />
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("complexName", value.target.value);
                            }}
                            fullWidth
                            type="text"
                            value={state.address.complexName || ""}
                            label="Complex Name"
                        />
                    </div>
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("floorNumber", value.target.value);
                            }}
                            fullWidth
                            type="number"
                            label="Floor Number"
                            value={state.address.floorNumber || ""}
                        />
                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("buildingName", value.target.value);
                            }}
                            fullWidth
                            type="text"
                            value={state.address.buildingName || ""}
                            label="Building Name"
                        />
                    </div>

                    <div style={{ ...styles.Row, zIndex: 20 }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                options={areaList}
                                isMulti={false}
                                value={state?.selectedArea?.areaId}
                                placeholder="Location"
                                onChange={(selectedArea) => {
                                    let fullArea = areaData.areas.find(x => x.areaId === selectedArea);
                                    setstate({
                                        ...state,
                                        selectedArea: fullArea,
                                        suburbId: fullArea.p24.suburbId,
                                        cityId: fullArea.p24.cityId,
                                        provinceId: fullArea.p24.provinceId,
                                    })
                                }}
                            />
                        </div>
                    </div>


                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.showLocation || false}
                                onChange={(e) => saveData("showLocation", e.target.checked)}
                            />
                            <span>Show Location On Map</span>
                        </div>
                    </div>

                    <div style={styles.DropdownWrapper}>
                        <CustomDropDownPicker
                            borderColor="grey"
                            options={locationOptions}
                            value={state.locationType}
                            onChange={(value) => saveData("locationType", value)}
                            placeholder="Publish Location As"
                        />
                    </div>

                </div>
            </div>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Pricing Details</p>
                </div>
                <div style={styles.CardBody}>
                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.poa}
                                onChange={(e) => saveData("poa", e.target.checked)}
                            />
                            <span>POA</span>
                        </div>
                    </div>
                    {!state.type && (
                        <p className="h6" style={styles.text}>Please select a listing type to see pricing fields</p>
                    )}
                    {(state.type === "sale" || state.type === "both") && (
                        <>
                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(value) => {
                                        value.preventDefault();
                                        saveData("deposit", value.target.value);
                                    }}
                                    type="text"
                                    label="Sale Deposit Price"

                                    value={state.deposit}
                                />
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(value) => {
                                        value.preventDefault();
                                        saveData("price", value.target.value);
                                    }}
                                    type="text"
                                    label="Sale Price"

                                    value={state.price}
                                />
                            </div>
                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(value) => {
                                        value.preventDefault();
                                        saveData("municipalValue", value.target.value);
                                    }}
                                    type="number"
                                    label="Municipal Value"
                                    value={state.municipalValue}
                                />
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(value) => {
                                        value.preventDefault();
                                        saveData("valuationPrice", value.target.value);
                                    }}
                                    type="number"
                                    label="Valuation Price"
                                    value={state.valuationPrice}
                                />
                            </div>
                        </>
                    )}
                    {(state.type === "tolet" || state.type === "both") && (
                        <div style={styles.Row}>
                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(value) => {
                                    value.preventDefault();
                                    saveData("deposit", value.target.value);
                                }}
                                type="text"
                                label="Rent Deposit Price"

                                value={state.deposit}
                            />
                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(value) => {
                                    value.preventDefault();
                                    saveData("grossmonthlyRental", value.target.value);
                                }}
                                type="text"
                                label="Gross Monthly Rental"

                                value={state.grossmonthlyRental}
                            />
                        </div>
                    )}
                    {state.type && (
                        <div style={styles.Row}>
                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(value) => {
                                    value.preventDefault();
                                    saveData("ppsm", value.target.value);
                                }}
                                type="number"
                                label="Price Per Square Meter"

                                value={state.ppsm}
                            />
                        </div>
                    )}
                    {state.poa && (
                        <p style={{ color: '#666', fontStyle: 'italic', marginTop: '-15px' }}>
                            Price fields are disabled when POA is selected. The listing will show "POA" instead of prices on public platforms.
                        </p>
                    )}
                </div>
            </div>
            <div style={styles.Card}>
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Owner Details</p>
                    <i style={{ cursor: "pointer" }} className="now-ui-icons ui-1_zoom-bold" onClick={() => {
                        toggleTwo();
                    }} />
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            saveUserData("ownername", value.target.value);
                        }}
                        type="text"
                        value={state.seller.ownername || ""}
                        label="Owner name"
                    />
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            saveUserData("company", value.target.value);
                        }}
                        type="text"
                        value={state.seller.company || ""}
                        label="Company Name"
                    />
                </div>
                <div style={styles.Row}>
                    <div style={{ flex: "1", marginRight: "10px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                saveUserData("registrationNumber", value.target.value);
                            }}
                            type="text"
                            value={state.seller.registrationNumber || ""}
                            label="Company Registration Number"
                        />
                    </div>
                    <div style={{ flex: "0 0 90px", marginRight: "3px" }}>
                        <PhoneInput
                            country={"za"}
                            value={state.seller.countryCode}
                            onChange={(code) => saveUserData("countryCode", code)}
                            inputStyle={{
                                width: "100%",
                                height: 55,
                                fontSize: 16,
                                borderRadius: 4,
                                border: `1px solid grey`,
                                backgroundColor: "white",
                                color: "grey",
                            }}
                            dropdownStyle={{ zIndex: 1000 }}
                        />
                    </div>
                    <div style={{ flex: "0 0 200px", marginRight: "10px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                let phone = value.target.value.replace(/\D/g, "");
                                if (phone.startsWith("0")) phone = phone.substring(1);
                                saveUserData("cellTel", phone);
                            }}
                            type="text"
                            value={state.seller.cellTel || ""}
                            required
                            label="Company Cell Number"
                        />
                    </div>
                    <div style={{ flex: "1" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                saveUserData("email", value.target.value);
                            }}
                            type="text"
                            required
                            value={state.seller.email || ""}
                            label="Company Email"
                        />
                    </div>
                </div>
            </div>
            <div style={styles.Card}>

                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Rates & Levies</p>
                </div>

                <div style={styles.Row}>

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyRates", value.target.value);
                        }}
                        type="text"
                        value={state?.seller?.monthlyRates || ""}
                        label="Monthly Rates(ex VAT)"
                    />

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyLevy", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.monthlyLevy || ""}
                        label="Monthly Levy(ex VAT)"
                    />

                </div>


                <div style={styles.Row}>

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyLevyPerSQM", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.monthlyLevyPerSQM || ""}
                        label="Monthly Levy Per m²"
                    />

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("specialLevy", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.specialLevy || ""}
                        label="Special Levy(ex VAT)"
                    />
                </div>
            </div>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Property Features</p>
                </div>

                <div style={styles.CardBody}>

                    {/* Row 1: Floor Loading & 3-phase Power */}
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.powerAmps}
                            onChange={(e) => saveData("powerAmps", e.target.value)}
                            label="Power (Amps)"
                        />



                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.threePhasePower || false}
                                onChange={(e) => saveData("threePhasePower", e.target.checked)}
                            />
                            <span>3-phase Power</span>
                        </div>
                    </div>


                    {/* Row 2: Truck Access & Yard Access */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={truckAccessOptions}
                                value={state.truckAccess}
                                onChange={(value) => saveData("truckAccess", value)}
                                placeholder="Truck Access"

                            />
                        </div>
                        <div style={styles.DropdownWrapper}>
                            <Input

                                variant="outlined"
                                fullWidth
                                type="number"
                                value={state.yardAccess}
                                onChange={(e) => saveData("yardAccess", e.target.value)}
                                label="Yard Access"
                            />
                        </div>
                    </div>






                    {/* Row 4: Height of Eaves & Roller Shutter Doors */}
                    <div style={styles.Row}>

                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.rollerShutterDoors || ""}
                            onChange={(e) => saveData("rollerShutterDoors", e.target.value)}
                            label="Roller Shutter Doors"
                        />

                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfRollerShutter || ""}
                            onChange={(e) => saveData("heightOfRollerShutter", e.target.value)}
                            label="Height of Roller Shutter Doors (m)"
                        />

                    </div>


                    {/* Row 5: Height of Roller Shutter Doors & Stud Height */}
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfEaves || ""}
                            onChange={(e) => saveData("heightOfEaves", e.target.value)}
                            label="Height of Eaves (m)"
                        />


                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.studHeight || ""}
                            onChange={(e) => saveData("studHeight", e.target.value)}
                            label="Stud Height (m)"
                        />
                    </div>

                    {/* Row 6: Height of Roof & Height for Racking */}
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfRoof || ""}
                            onChange={(e) => saveData("heightOfRoof", e.target.value)}
                            label="Height of Roof (m)"
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightForRacking || ""}
                            onChange={(e) => saveData("heightForRacking", e.target.value)}
                            label="Height for Racking (m)"
                        />
                    </div>

                    {/* Row 7: Dock Levellers & Height of Dock Levellers */}
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.dockLevellers || ""}
                            onChange={(e) => saveData("dockLevellers", e.target.value)}
                            label="Dock Levellers"
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfDockLevellers || ""}
                            onChange={(e) => saveData("heightOfDockLevellers", e.target.value)}
                            label="Height of Dock Levellers (m)"
                        />
                    </div>
                    {/* Row 3: Power (Amps) & Building Grade */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.floorLoading || ""}
                            onChange={(e) => saveData("floorLoading", e.target.value)}
                            label="Floor Loading Capacity (tn/m²)"
                        />


                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={buildingGrades}
                                value={state.buildingGrade}
                                onChange={(value) => saveData("buildingGrade", value)}
                                placeholder="Building Grade"
                            />
                        </div>
                    </div>
                    {/* Row 8: Security & Air Conditioning */}
                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.security || false}
                                onChange={(e) => saveData("security", e.target.checked)}
                            />
                            <span>Security</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.airConditioning || false}
                                onChange={(e) => saveData("airConditioning", e.target.checked)}
                            />
                            <span>Air Conditioning</span>
                        </div>
                    </div>

                </div>
            </div>
            <div style={styles.Card}>
                {/* Card Header */}
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Lease Details</p>
                    <button
                        style={styles.MinimizeBtn}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? "+" : "—"}
                    </button>
                </div>

                {/* Card Body */}
                <div style={styles.CardBody}>

                    {/* Row 1: Multi Tenanted & Lease Type */}
                    <div style={{ ...styles.Row, zIndex: 201, }}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.multiTenanted || false}
                                onChange={(e) => saveData("multiTenanted", e.target.checked)}
                            />
                            <span>Multi Tenanted</span>
                        </div>

                        <div style={{
                            position: 'relative',
                            width: '100%',
                            zIndex: 2000,
                            background: 'white',
                        }}
                        >
                            <CustomDropDownPicker
                                options={leaseTypes}
                                value={state.leaseType}
                                onChange={(value) => saveData("leaseType", value)}
                                placeholder="Lease Type"
                                borderColor="grey"
                            />
                        </div>
                    </div>

                    {/* Row 2: Lease Period & Deposit */}
                    <div style={{ ...styles.Row, zIndex: 200 }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                options={leasePeriods}
                                value={state.leasePeriod || ""}
                                onChange={(value) => saveData("leasePeriod", value)}
                                placeholder="Lease Period"
                                fullWidth
                                borderColor="grey"
                            />
                        </div>
                    </div>

                    {/* Row 3: Available From */}
                    <div style={styles.Row}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                options={availableFromOptions}
                                value={state.availableFrom || ""}
                                onChange={(value) => saveData("availableFrom", value)}
                                placeholder="Available From"
                                fullWidth
                                borderColor="grey"
                            />
                        </div>
                        {/* empty right column for alignment */}
                        <div></div>
                    </div>

                </div>
            </div>

            <div style={styles.Card}>
                {/* Card Header */}
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}> Mandate Details</p>
                    <button
                        style={styles.MinimizeBtn}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? "+" : "—"}
                    </button>
                </div>

                {/* Card Body */}
                <div style={styles.CardBody}>

                    {/* Row 1: Multi Tenanted & Lease Type */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                value={state.typeOfMandate || ""}
                                options={mandateTypes}
                                isMulti={false}
                                onChange={(e) => saveData("typeOfMandate", e)}
                                placeholder="Select A Mandate Type"
                            />
                        </div>

                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={state?.onMarketSince || null}
                            label="On Market Since"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                                setOnMarketSince(e.target.value)
                                saveData("onMarketSince", e.target.value)
                            }}
                        />
                    </div>

                    {/* Row 2: Lease Period & Deposit */}
                    <div style={styles.Row}>
                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={state?.mandateStartDate || null}
                            InputLabelProps={{ shrink: true }}
                            label="Mandate Start Date"
                            onChange={(e) => {
                                setMandateStartDate(e.target.value)
                                saveData("mandateStartDate", e.target.value)
                            }}
                        />

                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={state?.mandateEndDate || null}
                            InputLabelProps={{ shrink: true }}
                            label="Mandate End Date"
                            onChange={(e) => {
                                setMandateEndDate(e.target.value)
                                saveData("mandateEndDate", e.target.value)
                            }}
                        />
                    </div>

                    {/* Row 3: Available From */}
                    <div style={styles.Row}>
                        <div style={styles.DropdownWrapper}>
                            {/* / */}
                        </div>
                        {/* empty right column for alignment */}
                        <div></div>
                    </div>

                </div>
            </div>
            <div style={styles.Card}>
                {/* Card Header */}
                <div
                    style={{
                        ...styles.CardHeader,
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <p className="h4" style={styles.text}>Parking</p>
                </div>

                {/* Open Parking */}
                <div style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #e0e0e0" }}>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Open Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("openParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("openParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        onChange={(e) => saveData("openParkingTotalCost", e.target.value)}
                    />
                </div>

                {/* Covered Parking */}
                <div style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #e0e0e0" }}>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Covered Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("coveredParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("coveredParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => saveData("coveredParkingTotalCost", e.target.value)}
                    />
                </div>

                {/* Basement Parking */}
                <div>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Basement Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("basementParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("basementParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => saveData("basementParkingTotalCost", e.target.value)}
                    />
                </div>
            </div>
            <div style={styles.Card}>
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Dimensions Details</p>
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("gla", value.target.value);
                        }}
                        value={state.gla || ""}
                        type="text"
                        required
                        label="Total Size of Property "
                    />
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            saveData("floorSize", value.target.value);
                        }}
                        value={state.floorSize || ""}
                        type="text"
                        label="Floor Size"
                    />
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("landSize", value.target.value);
                        }}
                        type="text"
                        value={state.landSize || ""}
                        label="Land Size"
                    />
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("officeSize", value.target.value);
                        }}
                        type="text"
                        value={state.officeSize || ""}
                        label="Office Size"
                    />
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("retailSize", value.target.value);
                        }}
                        type="text"
                        value={state.retailSize || ""}
                        label="Retail Size"
                    />
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("factorySize", value.target.value);
                        }}
                        type="text"
                        value={state.factorySize || ""}
                        label="Factory Size"
                    />
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("yardSize", value.target.value);
                        }}
                        type="text"
                        value={state.yardSize || ""}
                        label="Yard Size"
                    />
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("buildingHieght", value.target.value);
                        }}
                        type="text"
                        value={state.buildingHieght || ""}
                        label="Building Height"
                    />
                </div>
            </div>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Marketing Details</p>
                </div>
                <div style={styles.Row}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("marketingHeading", value.target.value);
                        }}
                        type="text"
                        value={state.marketingHeading || ""}
                        label="Marketing Heading"
                    />
                </div>
                <div style={styles.Row}>
                    <Input
                        multiline
                        variant="outlined"
                        rows={4}
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("description", value.target.value);
                        }}
                        type="text"
                        value={state.description || ""}
                        label="Marketing Description"
                    />
                </div>
            </div>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Media Details</p>
                </div>

                <div style={{ ...styles.Row, justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <RSInput
                            innerRef={fileInputRef}
                            onChange={onImageChange}
                            type="file"
                            multiple
                            accept="image/*"
                            style={{ display: "none" }}
                        />
                        <Button color="primary" style={{
                            backgroundColor: STYLES.PRIMARY_APP_CLR,
                            color: "white",
                            width: "fit-content",
                            height: 44,
                            borderRadius: 8,
                            fontSize: 16,
                            fontWeight: "bold",
                            marginTop: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            padding: "0 20px",
                            cursor: "pointer"
                        }} onClick={handleButtonClick}>
                            Upload Images
                        </Button>
                    </div>
                </div>

                <div style={{ marginBottom: 50 }}>
                    <CustomImageDragger
                        data={image}
                        setValue={setImage}
                        captionsData={captions}
                        setCaptionsData={setCaptions}
                    />
                </div>
                <div style={{ ...styles.Row, justifyContent: 'center', alignItems: 'center' }}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("youtubeLinkId", value.target.value);
                        }}
                        type="text"
                        label="Youtube Video ID"
                        value={state.youtubeLinkId || ""}
                    />
                </div>
            </div>
            <div style={styles.Card}>
                <Button
                    style={{}}
                    onClick={() => {
                        let ListingData = {
                            ...state,
                            address: {
                                coords: state.address.coords || { lat: 0.0, lng: 0.0 },
                                description: state.address.description || " ",
                                suburb: state.address.description || " ",
                                address: state.address.description || " ",
                                streetNumber: state.address.streetNumber || " ",
                                streetName: state.address.streetName || " ",
                                unitNumber: state.address.unitNumber || " ",
                                complexName: state.address.complexName || " ",
                                floorNumber: state.address.floorNumber || " ",
                                buildingName: state.address.buildingName || " ",
                            },

                            images: validImages,

                            syndicateFlags: {
                                ...data.syndicateFlags,
                                privateProperty: false,
                                website: false,
                                property24: false,
                            },
                            //resetting P24 fields
                            ListingId: null,
                            listingNumber: null,
                            propertyTypeId: null,
                            P24expiryDate: null,
                            P24Status: null,
                            publishedProp24: null,
                            p24propertyType:null,
                            //resetting API website feilds
                            publishedAPIWeb: false,
                            wsListingId: null,
                            //resetting PP fields
                            publishedPP: false,
                            privateprop: false,
                        };
                        if (re.test(ListingData.seller.email) || phoneRegex.test(ListingData.seller.cellTel)) {
                            if (state.gla) {
                                if (ListingData.address?.description?.trim()) {
                                    // Check if images are provided
                                    if (!image || image.length === 0) {
                                        alert(
                                            "Please upload at least one image before creating the listing."
                                        );
                                    } else {

                                        if (ListingData.locationType) {


                                            if (ListingData.selectedArea) {
                                                dispatch(duplicateListing(ListingData));
                                            } else {
                                                alert("Please Provide a Location");
                                            }

                                        }
                                        else {
                                            alert("Please Provide a location Type");
                                        }
                                    }
                                } else {
                                    alert("Address is a required field.");
                                }
                            } else {
                                alert("Gross lettable area is a required field.");
                            }
                        } else {
                            alert("Please provide a proper email address or phone number.");
                        }
                    }}
                >
                    Duplicate Listing
                </Button>
            </div>
            <RenderModal />
        </div>
    );
}
export default StaffDuplicateListing;